import Glide from '@glidejs/glide'
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';

const init = () => {
    try {
        const sliderElement = document.querySelector('.glide');
        const slideCount = document.querySelector('.glide__slides').children.length;

        if (!sliderElement) return;
        const glide = new Glide('.glide', {
            type: 'slider',
            autoplay: 5000,
            startAt: slideCount === 1 ? 0 : 1,
            gap: 50,
            peek: {
                before: 100,
                after: 100
            },
            breakpoints: {
                800: {
                    gap: 25,
                    peek: {
                        before: 0,
                        after: 0
                    }
                }
            }
        });

        glide.mount();
    } catch {}
}

export default { init };